import React from 'react';
import ContactInfoCard from './contact/ContactInfoCard';
import ContactForm from './contact/ContactForm';
import ContactCTA from './contact/ContactCTA';

const Contact = () => {
  const whatsappNumber = '41784417112';
  const phoneNumber = '0784417112';
  const email = 'floria@malerfixpreis.ch';

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hallo,%20ich%20möchte%20ein%20Fixpreis-Angebot%20für%20Malerarbeiten%20anfragen.`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-slate-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Jetzt Fixpreis für Ihre Wohnung anfragen
            </h2>
            <p className="text-xl text-slate-600">
              Senden Sie uns einfach Fotos, ein kurzes Video oder die m²-Zahl Ihrer Wohnung per WhatsApp. Sie erhalten schnell ein unverbindliches Angebot.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <ContactInfoCard phoneNumber={phoneNumber} email={email} />
              <ContactCTA onWhatsApp={handleWhatsApp} onCall={handleCall} />
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
